import { App } from 'vue'
import AuthCodeInputs from './AuthCodeInputs.vue'
import BillCodesToArray from './BillCodesToArray.vue'
import BoxModeSwitch from './BoxModeSwitch.vue'
import BoxSearch from './BoxSearch.vue'
import JtDetail from './JtDetail.vue'
import JtFormItem from './JtFormItem'
import LangSelect from './LangSelect.vue'
import TableCount from './TableCount.vue'

const components = [
  AuthCodeInputs,
  BillCodesToArray,
  BoxModeSwitch,
  BoxSearch,
  JtDetail,
  JtFormItem,
  LangSelect,
  TableCount,
]

export default {
  install(app: App) {
    components.forEach((component) => {
      // @ts-ignore
      app.component(component.name || component.__name, component)
    })
  }
}
